import { cn } from "../../lib/utils";

export const PlanHierarchyIcon = ({ level, className, classNameIcon }) => {
	const isBranchLevel = level === "branch";

	return (
		<div
			className={cn(
				"size-[40px] bg-primary-10 flex items-center justify-center rounded-[4px]",
				className
			)}
		>
			<span
				className={cn(
					"icon_24 default icon_mask !bg-primary-100 piano",
					isBranchLevel && "branch",
					classNameIcon
				)}
			></span>
		</div>
	);
};
